import {Field} from '../../../model/search/advanced/Field';
import {DateRangeField} from '../../../model/search/advanced/DateRangeField';
import {NumberRangeField} from '../../../model/search/advanced/NumberRangeField';
import {MultiFullTextField} from '../../../model/search/advanced/MultiFullTextField';
import {MultiTextField} from '../../../model/search/advanced/MultiTextField';
import {SingleFullTextField} from '../../../model/search/advanced/SingleFullTextField';
import {SingleTextField} from '../../../model/search/advanced/SingleTextField';
import {AdvancedSearch} from '../../../model/search/advanced/AdvancedSearch';
import {SearchVisibility} from '../../../model/search/advanced/SearchVisibility';

import {AccountService, Factory} from '../../../services';
import {Utilities} from "../../../Utilities";
import {SearchService} from "../../../services/search/advanced/SearchService";


export interface ISelectorScope extends angular.IScope {
  fields: Field[];
  project;
  isOpen: boolean;
  account: any;
  savedSearches: AdvancedSearch[];
  currentSearch;
  isInstanceOf: Function;
  deleteSearch: Function;
  editSearch: Function;
  openPopover: Function;
  closePopover: Function;
  toggleSearchVisibility: Function;
  DateRangeField;
  NumberRangeField;
  MultiFullTextField;
  MultiTextField;
  SingleFullTextField;
  SingleTextField;
  SearchVisibility;
  ShareSearchTemplateUrl;
}

export interface IFieldSelectorAttributes extends angular.IAttributes {
}

export class Selector implements angular.IDirective {
  public restrict = 'E';
  public templateUrl: string;
  public scope = {fields: '=ngModel', project: "=", savedSearches: "="};
  public require = ['ngModel'];
  public link: (scope: ISelectorScope, element: angular.IAugmentedJQuery, attrs: IFieldSelectorAttributes) => void;

  constructor(rootScope: IRootScope, searchService: SearchService, accountService: AccountService) {
    this.templateUrl = "partials/search/advanced/selector.html";
    this.link = (scope: ISelectorScope, element: angular.IAugmentedJQuery, attrs: IFieldSelectorAttributes) => {
      scope.isOpen = true;
      scope.DateRangeField = DateRangeField;
      scope.NumberRangeField = NumberRangeField;
      scope.MultiFullTextField = MultiFullTextField;
      scope.MultiTextField = MultiTextField;
      scope.SingleFullTextField = SingleFullTextField;
      scope.SingleTextField = SingleTextField;
      scope.isInstanceOf = Utilities.isInstanceOf;
      scope.SearchVisibility = SearchVisibility;
      scope.ShareSearchTemplateUrl = "partials/search/advanced/share_search_popover.html";

      scope.account = accountService.Get();

      scope.openPopover = (e, search) => {
        if (scope.currentSearch) {
          scope.currentSearch.popoverOpen = false;
        }

        scope.currentSearch = search;
        scope.currentSearch.popoverOpen = true;
        e.stopPropagation();
      };

      scope.closePopover = () => {
        if (scope.currentSearch) {
          scope.currentSearch.popoverOpen = false;
        }

        scope.currentSearch = null;
      };

      scope.deleteSearch = search => {
        searchService.Delete(scope.project, search.id).then(() => {
          rootScope.$broadcast("AdvancedSearch.Deleted", search.id);
        });
      };

      scope.editSearch = (search: AdvancedSearch) => {
        rootScope.$broadcast("AdvancedSearch.Edit", search);
      };

      scope.toggleSearchVisibility = (search: AdvancedSearch) => {
        searchService.ToggleVisibility(scope.project, search.id).then((updatedSearch: AdvancedSearch) => {
          search.visibility = updatedSearch.visibility;
          search.accounts = updatedSearch.accounts;
          search.roles = updatedSearch.roles;
        });
      };

      scope.$watch("project", project => {
        if (project) {
          searchService.FindAll(project).then((searches) => {
            scope.savedSearches = AdvancedSearch.FromList(searches);
          });
        }
      });

      scope.$on("AdvancedSearch.Saved", () => {
        searchService.FindAll(scope.project).then((searches) => {
          scope.savedSearches = AdvancedSearch.FromList(searches);
          rootScope.$broadcast("AdvancedSearch.ListUpdated", searches);
        });
      });

      scope.$on("AdvancedSearch.Deleted", () => {
        searchService.FindAll(scope.project).then((searches) => {
          scope.savedSearches = AdvancedSearch.FromList(searches);
          scope.$apply();
        });
      });

      scope.$on("SearchMode.Basic", () => scope.closePopover());

      rootScope.$on("AccountService.accountUpdated", (e, account) => scope.account = account);
    };
  }
}

frontendApp.directive("iioAdvancedSearchSelector", ["$rootScope", "AdvancedSearchService", "AccountService", Factory.Create(Selector)]);
